module.exports = __webpack_public_path__ + "img/pellets-silowagen-mobile.6144c2e.png";